const IsVisible = [{Name:'可见',Value:'Y'},{Name:'隐藏',Value:'N'}]
const IsEnabled = [{Name:'可用',Value:'Y'},{Name:'禁用',Value:'N'}]
const IsMoreSign = [{Name:'是',Value:'Y'},{Name:'否',Value:'N'}]
const IsLocked = [{Name:'锁定',Value:'Y'},{Name:'正常',Value:'N'}]
const Gender = [{Name:'男',Value:'男'},{Name:'女',Value:'女'}]
const OpenType = [{Name:'内部嵌入',Value:'1'},{Name:'浏览器弹出',Value:'2'}]
const ActionType = [{Name:'Post',Value:2},{Name:'Get',Value:1}]
const MenuType = [{Name:'工具栏',Value:1},{Name:'两者',Value:2},{Name:'右键',Value:3},{Name:'操作栏',Value:4}]
const IsAudited = [{Name:'审核',Value:'Y'},{Name:'不审',Value:'N'}]
const IsPub = [{Name:'是',Value:'Y'},{Name:'否',Value:'N'}]
const PWUpdateMonth = [{Name:'永不过期',Value:240},{Name:'一年',Value:12},{Name:'六个月',Value:6},{Name:'三个月',Value:3},{Name:'一个月',Value:1}]
const Operation = [{Name:'上传',Value:0},{Name:'在线预览',Value:1},{Name:'下载',Value:2},{Name:'重新上传',Value:3},{Name:'删除',Value:4}]
const Audit = [{Name:'通过',Value:4},{Name:'不通过',Value:3}]
const IsRead = [{Name:'全部',Value:''},{Name:'已读',Value:'Y'},{Name:'未读',Value:'N'}]
const IsCommon = [{Name:'是',Value:'Y'},{Name:'否',Value:'N'}]
const UserType = [{Name:'个人',Value:'个人'},{Name:'单位',Value:'单位'}]
const DefaultClassification = [
    {ID:"0b0ef52052984382a536b16fd83ed97e",Name:"审核",Value:"Audit"},
    {ID:"149ef39249ce4622970e1e0f3d933684",Name:"修改",Value:"Edit"},
    {ID:"5cf932adb5d24d3790bd1a111a528041",Name:"查询",Value:"Read"},
    {ID:"b566602e36a24d51a610f9d410ba94b2",Name:"删除",Value:"Delete"},
    {ID:"f3787199d183433bb6298022bb51456a",Name:"新增",Value:"Add"}
]
const DefaultActionData = ["Read","Add","Edit","Delete","Audit"]
export  {
    IsVisible,
    IsEnabled,
    IsLocked,
    IsMoreSign,
    Gender,
    OpenType,
    ActionType,
    MenuType,
    IsAudited,
    DefaultClassification,
    DefaultActionData,
    IsPub,
    PWUpdateMonth,
    Operation,
    Audit,
    IsRead,
    IsCommon,
    UserType
}



// WEBPACK FOOTER //
// ./src/areas/systemmanage/config/localDictionary.js